<template>
    <div class="container">
        <div>
            <QuillEditor ref="editor" theme="snow" toolbar="full" @update:content="() => {
                this.$emit('onchange', {
                    key: this.meta.key,
                    value: this.$refs.editor.getHTML(),
                    hint: '',
                    error: false
                })
            }" />
        </div>
    </div>
</template>

<script>
/* eslint-disable */

export default {
    name: 'Editor',
    props: ['meta', 'vm'],
    inject: ['base'],
    created() {
        this.setHTML()
    },
    watch: {
        vm(newVM, oldVM) {
            this.setHTML()
        }
    },
    methods: {
        setHTML() {
            const editor = this.$refs?.editor
            if (editor)
                editor.setHTML(this.vm)
            else
                setTimeout(() => {
                    this.setHTML()
                }, 100);
        }
    }
}
</script>

<style scoped src="../../../assets/css/components/inputs/editor.css"></style>